<template>
     <div class="themeScream">
          <theme-list></theme-list>
          <Swiper class="theme_img" v-if="imagePath.length > 0" duration="1000">
               <Slide v-for="(item,index) in imagePath" :key="index">
                    <img :src="weburl+item" alt="">
               </Slide>
          </Swiper>
          <div class="theme_bg"
               v-bind:style="{backgroundImage: 'url(static/img/theme_1.png)', backgroundSize:'cover'}">
               <h3>{{$t('theme_bg_tit')}}</h3>
               <p v-html="park_lists.desc"></p>
          </div>
          <div class="flex_box">
               <themeItem v-for="(p,n) in park_lists.category" :parks_info="p" :key='n'></themeItem>
          </div>
     </div>
</template>

<script>
import themeItem from "../../components/parks/themeItem";
import { Swiper, Slide } from "vue-swiper-component";
import themeList from "../../components/parks/themeList";
export default {
  name: "themeScream",
  components: {
    themeItem,
    Swiper,
    Slide,
    themeList
  },
  data: function() {
    return {
      imagePath: [],
      park_lists: {}
    };
  },
  created: function() {
    this.$store.commit("set_park_index", 0);
    this.$store.commit("set_current", 1);
    this.$store.commit("set_title", "nav.theme");
    this.getInfoData(1);
  },
  inject: ["showMsg"],
  methods: {
    //    获取数据的方法
    getInfoData(id) {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + "home/theme/getTheme",
        dataType: "json",
        data: {
          park_id: id,
          lang: window.$lang
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.imagePath = res.data.result.mobile_url;
            this.park_lists = res.data.result;
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    }
  },
  computed: {
    //计算属性，
    weburl() {
      return this.$store.state.weburl;
    },
    current() {
      return this.$store.state.home.current;
    },
    park_index() {
      return this.$store.state.park.park_index;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/nav.less";

.themeScream {
  width: @width;
  .theme_img {
    width: @width;
    /*height: 210px;*/
    img {
      //.img;
      width: @width;
    }
  }
  .theme_bg {
    width: @width;
    height: 145px;
    padding: 12px;
    .box-sizing;
    color: @font-primary;
    .border-bottom(5px, @bg);
    h3 {
      font-size: @font;
      margin-bottom: 5px;
    }
    p {
      font-size: @font - 0.2;
      text-indent: $font-size * 2;
      height: 92px;
      line-height: 18px;
      overflow-y: auto;
      ::-webkit-scrollbar {
        display: none;
      }
    }
  }
}

.lists li.lists_active {
  color: #feb302;
  &:after {
    background: #feb302;
  }
}

@media (min-width: 768px) and (orientation: portrait) {
  .themePark {
    .theme_bg {
      height: 180px;
      padding: 20px;
      h3 {
        font-size: @font + 0.4;
        margin-bottom: 12px;
      }
      p {
        font-size: @font + 0.2;
        text-indent: $font-size * 2;
        height: 110px;
        line-height: 22px;
        overflow-y: auto;
        ::-webkit-scrollbar {
          display: none;
        }
      }
    }
  }
}
</style>
